import { errorHandler } from '@/app/shared/services/error-handler.js';

export default {

  fetchKPUListItems({ commit }) {
    return new Promise((resolve, reject) => {

      this._vm.$webApi.get("cashflow/kpu")
        .then((response) => {
          commit('SET_KPUS', response.data)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  removeKPU({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('cashflow/kpu/' + itemId)
        .then((response) => {
          commit('REMOVE_KPU', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  fetchProjectLeaders({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$graphApi.get("/groups/" + this.$store.state.activeDirectoryConfigurations.cashflowProjectLeadersGroupId + "/members")
        .then((response) => {
          commit('SET_PROJECT_LEADERS', response.data.value)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.loadingError(this._vm, error);
          reject(error) 
        })
    })
  },

  fetchKeyProjectTypes({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("cashflow/keyprojecttype")
        .then((response) => {
          commit('SET_KEY_PROJECT_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.loadingError(this._vm, error);
          reject(error) 
        })
    })
  },

  addKeyProjectType({ commit }, keyProjectType) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/keyprojecttype/', keyProjectType)
        .then((response) => {
          commit('ADD_KEY_PROJECT_TYPE', Object.assign(keyProjectType, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateKeyProjectType({ commit }, keyProjectType) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/keyprojecttype/', keyProjectType)
        .then((response) => {
          commit('UPDATE_KEY_PROJECT_TYPE', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeKeyProjectType({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('cashflow/keyprojecttype/' + itemId)
        .then((response) => {
          commit('REMOVE_KEY_PROJECT_TYPE', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  fetchKeyProjects({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.get("cashflow/keyproject")
        .then((response) => {
          commit('SET_KEY_PROJECTS', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.loadingError(this._vm, error);
          reject(error) 
        })
    })
  },

  addKeyProject({ commit }, keyProject) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/keyproject/', keyProject)
        .then((response) => {
          commit('ADD_KEY_PROJECT', Object.assign(keyProject, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },
  updateKeyProject({ commit }, keyProject) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.post('cashflow/keyproject/', keyProject)
        .then((response) => {
          commit('UPDATE_KEY_PROJECT', response.data)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeKeyProject({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$webApi.delete('cashflow/keyproject/' + itemId)
        .then((response) => {
          commit('REMOVE_KEY_PROJECT', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  }
}
